var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-quill/~/lodash/_Symbol.js
 ** module id = 668
 ** module chunks = 0
 **/